import { render } from "./TotalShoppingForYearReportGrapics.vue?vue&type=template&id=f50e7342"
import script from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__